// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cheapest-deliveries__title{font-size:16px;line-height:24px;width:100%;text-align:left;padding:8px 0 8px 16px}", ""]);
// Exports
module.exports = exports;
